"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 'auto',
        fill: theme.grey7,
        '&[data-is-white=true]': {
            fill: theme.white1,
            padding: 1
        }
    }
});
//# sourceMappingURL=avatar.group.border.style.js.map